/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 7th 2022, 9:04:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { SALES_EMAIL } from "config";
import { FullScreenNotificationGrid, EmphasisText, Image } from "ui-widgets";

export const SubscriptionServiceUnreachable = () => {
  return (
    <FullScreenNotificationGrid
      pageTitle={<>Subscription Service Unreachable</>}
      pageContent={
        <p>
          The Onestop Subscription Service is Unreachable. Kindly contact <EmphasisText>{SALES_EMAIL}</EmphasisText> if
          this is an on-premise enterprise installation or developer environment.
        </p>
      }
      pageIllustration={<Image src="/img/no-conexion.png" width={128} height={128} />}
    />
  );
};
